export const posts = [
  {
    slug: 'disenar-apis-versionables',
    title: 'Como disenar APIs versionables sin frenar al producto',
    excerpt:
      'Una guia practica para separar contratos publicos, modelos internos y reglas de compatibilidad cuando el negocio cambia rapido.',
    date: '2026-05-20',
    readingMinutes: 7,
    tags: ['API Design', 'Arquitectura', 'Backend'],
  },
  {
    slug: 'observabilidad-en-servicios',
    title: 'Observabilidad minima para servicios backend en produccion',
    excerpt:
      'Logs estructurados, metricas tecnicas y trazas que ayudan a diagnosticar problemas antes de que se conviertan en incidentes.',
    date: '2026-05-12',
    readingMinutes: 6,
    tags: ['Observabilidad', 'SRE', 'Cloud'],
  },
  {
    slug: 'cache-sin-inconsistencias',
    title: 'Cachear sin romper la consistencia de datos',
    excerpt:
      'Patrones de invalidacion, TTLs y lectura defensiva para mejorar latencia sin esconder bugs dificiles de reproducir.',
    date: '2026-04-29',
    readingMinutes: 8,
    tags: ['Performance', 'Datos', 'Escalabilidad'],
  },
];
